var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('body', {
    attrs: {
      "background": "static/img/Heavy-Duty-Warehouse-Trucks-in-Miami.jpg"
    }
  }, [_c('section', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "app2 flex-row align-items-center"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row justify-content-center"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-8 col-lg-8"
  }, [_c('div', {
    staticClass: "card-group mb-0"
  }, [_c('div', {
    staticClass: "card p-4"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('img', {
    staticClass: "dark-logo",
    attrs: {
      "src": "static/img/newlogo.png",
      "alt": "homepage"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.errormsg != '') ? _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger",
      "dismissible": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.errormsg) + "\n                      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.successmsg != '') ? _c('div', [_c('b-alert', {
    attrs: {
      "show": "",
      "variant": "success",
      "dismissible": ""
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.successmsg) + "\n                      ")])], 1) : _vm._e(), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "id": "forgotpasswordform"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('h4', [_vm._v("Forgot Password")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-form-fieldset', [_c('b-input-group', {
    attrs: {
      "left": "<i class='icon-user'></i>"
    }
  }, [_c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('email')
    },
    attrs: {
      "type": "email",
      "placeholder": "Please Enter Email Address",
      "name": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('email')),
      expression: "errors.has('email')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('email')))])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('b-button', {
    staticClass: "glasssec",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Cancel")])], 1)])])], 1)]), _vm._v(" "), _vm._m(1)])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-6"
  }, [_c('button', {
    staticClass: "btn btn-primary px-4",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card text-center text-white py-5 d-md-down-none",
    staticStyle: {
      "width": "40%",
      "background-color": "#f58220 !important"
    }
  }, [_c('h4', {
    staticClass: "login_title"
  }, [_vm._v("Delivering Happiness")]), _vm._v(" "), _c('div', {
    staticClass: "card-body text-center"
  }, [_c('div', [_c('p', {
    staticClass: "xb_text"
  }, [_vm._v("Instantly grow your e-commerce business through our extensive network and create happy customers through value added services and on time delivery")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c6b1fa2","hasScoped":true}!./src/views/components/resetpasswordwith2fa/resetpasswordwith2fa.component.html
// module id = 934
// module chunks = 1